import Passholders from "./Passholders";
import './passholders.scss';

export default Passholders;